import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function confirmSignup(
  confirmationId,
  signupId,
  forceIsBooking,
  language,
  timeZone,
  cancelToken
) {

  try {
    // POST: it changes the signup. The parameters stay in the query string.
    const data = await wsRequestPost(
      "/admin/ConfirmationEmail/confirm",
      language,
      timeZone,
      null,
      { signupId, confirmationId, forceIsBooking },
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to confirm the signup: ${e}`);
    // 404 (unknown email) and 409 (already attached) answer with the same
    // { success, message } body as a success, carrying the reason.
    const body = e?.payload?.responseData;
    return {
      success: false,
      message: body?.message || body?.Message || e?.payload?.translatedMessage || undefined,
    };
  }
}

export async function relayRun(confirmationId, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/ConfirmationEmail/play",
      language,
      timeZone,
      {confirmationId},
      cancelToken
    );
    return {
      success: true,
      data: data
    };
  } catch (e) {
    console.error(`unable to run the relay: ${e}`);
    return {
      success: false,
      data: e
    };
  }
}

export async function getConfirmationById(confirmationId, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      "/admin/ConfirmationEmail/email",
      language,
      timeZone,
      {confirmationId},
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to get confirmation with id "${confirmationId}": ${e}`);
    return {
      success: false,
    };
  }
}

export async function searchConfirmations(options, language, timeZone, cancelToken) {
  const { filters } = options;
  const {
    orderBy,
    orderDirection,
    id,
    page,
    signupId,
    createdFrom,
    createdTo,
    hasSignup,
    resultsPerPage,
    seasonalCourtPurchaseId,
    sender,
    subject,
  } = filters;

  const params = {
    OrderBy: orderBy || "createdDate",
    OrderDirection: orderDirection || "desc",
    Page: page || 1,
    ResultsPerPage: resultsPerPage || 15,
    Id: id || undefined,
    SignupId: signupId || undefined,
    CreatedFrom: createdFrom || undefined,
    CreatedTo: createdTo || undefined,
    HasSignup: hasSignup || undefined,
    SeasonalCourtPurchaseId: seasonalCourtPurchaseId || undefined,
    Sender: sender || undefined,
    Subject: subject || undefined,
  };

  try {
    const data = await wsRequestGet(
      "/admin/ConfirmationEmail/search",
      language,
      timeZone,
      params,
      cancelToken
    );
    return data;
  } catch (e) {
    console.error(`unable to get confirmations: ${e}`);
    return {
      success: false,
    };
  }
}
